import { Injectable } from '@angular/core';
import FuzzySearch from 'fuzzy-search';
import { HttpClient } from '@angular/common/http';

import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

interface IPrintConfig {
    headCss?: boolean;
    extraCss?: string;
    pageCss?: string;
    title?: string;
}

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    defaultSecretKey: string = "COPEIAENCRYPT";

    constructor(private http: HttpClient) {
    }

    getAPIConfig() {
        var time = new Date().getTime();
        return this.http.get<any>(`${environment.APIUrl}/json/APIConfig.json?time=${time}`);
    }

    getICD10Codes() {
        var time = new Date().getTime();
        return this.http.get<any>(`${environment.APIUrl}/json/icd10gm.json?time=${time}`);
    }

    saveDocCheckLoginLogName(LoginLogName) {
        let payload = { LoginLogName };
        let baseUrl = window.location.hostname.indexOf("localhost") >= 0 ? "https://localhost:44369" : "https://copeia.de";
        return this.http.post<any>(`${baseUrl}/api/DocCheck/LoginLogName`, payload);
    }

    saveDateneingabeData(payload) {
        return this.http.post<any>(`${environment.APIUrl}/api/dateneingabe`, payload);
    }

    searchDatenebank(payload) {
        return this.http.post<any>(`${environment.APIUrl}/api/dateneingabe/search`, payload);
    }

    searchDatenebankEN(payload) {
        return this.http.post<any>(`${environment.APIUrl}/api/dateneingabe/en/search`, payload);
    }

    getDatenebankByUniqueId(uniqueId) {
        return this.http.get<any>(`${environment.APIUrl}/api/dateneingabe/detail/${uniqueId}`);
    }

    getDatenebankENByUniqueId(uniqueId) {
        return this.http.get<any>(`${environment.APIUrl}/api/dateneingabe/en/detail/${uniqueId}`);
    }

    getDateneingabeDDL() {
        return this.http.get<any>(`${environment.APIUrl}/api/dateneingabe/dropdown`);
    }

    getDateneingabeENDDL() {
        return this.http.get<any>(`${environment.APIUrl}/api/dateneingabe/en/dropdown`);
    }

    getHeatMapData() {
        return this.http.get<any>(`${environment.APIUrl}/api/datenubersicht/heatmap`);
    }

    getHeatMapENData() {
        return this.http.get<any>(`${environment.APIUrl}/api/datenubersicht/en/heatmap`);
    }

    //////////////////////////////////////////

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    performClick(elemId) {
        var elem = document.getElementById(elemId);
        if (elem && document.createEvent) {
            var evt = document.createEvent("MouseEvents");
            evt.initEvent("click", true, false);
            elem.dispatchEvent(evt);
        }
    }

    encryptUsingAES256(value, secretKey) {
        try {
            return CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
        } catch (ex) {
            alert("Unable to encrypt file");
        }
    }

    decryptUsingAES256(value, secretKey) {
        try {
            const bytes = CryptoJS.AES.decrypt(value, secretKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
            return value;
        } catch (ex) {
            alert("Unable to decrypt file. Either the file is modified or the Secret key is not valid.");
        }
    }

    convertToHash(value) {
        var hash = CryptoJS.SHA3(value).toString();
        return hash;
    }

    fuzzySearch(data, column, search) {
        const searcher = new FuzzySearch(data, [column]);
        const result = searcher.search(search);
        return result;
    }

    downladJSON(fileName, secretType, secretKey, jsonObj) {
        var jsonString = JSON.stringify(jsonObj);
        var saveJSON = {
            jsonType: secretType,
            secretKey: false,
        }

        if (secretType == 'encrypted') {
            var encryptSecretKey = this.defaultSecretKey;
            if (secretKey.trim()) {
                encryptSecretKey = secretKey;
                saveJSON["secretKey"] = true;
            }
            jsonString = this.encryptUsingAES256(jsonObj, encryptSecretKey);
        }
        saveJSON["data"] = jsonString;
        this.downloadJSONFile(fileName, saveJSON);
    }

    async downloadJSONFile(fileName, data) {
        data = JSON.stringify(data);
        fileName = fileName + '.json';
        let fileHandle;
        var hasFSAccess = 'chooseFileSystemEntries' in window || 'showOpenFilePicker' in window;
        if (hasFSAccess) {
            try {
                fileHandle = await this.getFileHandle(fileName);
            } catch (ex) {
                if (ex.name === 'AbortError') {
                    return;
                }
            }
        }
        if (fileHandle) {
            const writableFileStream = await fileHandle.createWritable();
            if (writableFileStream) {
                var taBlob = new Blob([data], { type: 'text/json' });
                await writableFileStream.write(taBlob);
                await writableFileStream.close();
            }

        } else {
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(data);
            var fileDownload = document.createElement("a");
            document.body.appendChild(fileDownload);
            fileDownload.href = dataStr;
            fileDownload.download = fileName;
            fileDownload.click();
            document.body.removeChild(fileDownload);
        }
    }

    getFileHandle(fileName) {
        let _window: any = window;
        // For Chrome 86 and later...
        if ('showSaveFilePicker' in window) {
            const opts = {
                suggestedName: fileName,
                types: [{
                    description: 'json file',
                    accept: { 'text/json': ['.json'] },
                }],
            };
            return _window.showSaveFilePicker(opts);
        }
        // For Chrome 85 and earlier...
        const opts = {
            suggestedName: fileName,
            type: 'save-file',
            accepts: [{
                description: 'json file',
                extensions: ['json'],
                mimeTypes: ['text/json'],
            }],
        };
        return _window.chooseFileSystemEntries(opts);
    }

    printHTMLData(html, config?: IPrintConfig) {
        let pageCss: any = `<style>\@@page {size: 25mm 25mm; margin: 0; }</style>`;
        let headHTML = "";
        let extraCss = "";
        if (config) {
            if (config.pageCss) {
                pageCss = config.pageCss;
            }
            if (config.headCss) {
                headHTML = document.head.innerHTML;
            }
            if (config.extraCss) {
                extraCss = config.extraCss;
            }
            if (config.title) {
                headHTML = headHTML.replace(/<title>.*?<\/title>/g, `<title>${config.title}</title>`);
            }
        }
        var printData = `<html>${pageCss}${headHTML}${extraCss}<body onload="window.print();">${html}</body></html>`;
        var newWin = window.open("about:blank", "_new");
        newWin.document.write(printData);
        newWin.document.close();
    }

    exportHTMLToDOC(html) {
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'><title></title></head><body>";
        var footer = "</body></html>";

        var sourceHTML = header + html + footer;

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'Medizinalcannabis-Antrag.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
    }


    setJsPanelProperty(jsPanelElm) {
        jsPanelElm.header.style.backgroundColor = "#0087FF";
        return jsPanelElm;
    }

    //////////////////////////////////////////

    generateColors(total, hex) {
        if (total === 1) {
            return ["#cc2929"];
        }
        let colors = [];
        var x = 360 / (total - 1);
        var sv = 70;
        for (var i = 0; i < total; i++) {
            sv = sv > 90 ? 70 : sv + 10;
            let hsv = this.hsvToRgb(i * x, sv, sv);
            if (hex) {
                let color = this.rgbToHex(hsv[0], hsv[1], hsv[2]);
                colors.push(color);
            } else {
                let color = `rgb(${hsv[0]},${hsv[1]},${hsv[2]})`;
                colors.push(color);
            }
        }
        return colors;
    }

    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

    hsvToRgb(h, s, v) {
        var r, g, b;
        var i;
        var f, p, q, t;

        // Make sure our arguments stay in-range
        h = Math.max(0, Math.min(360, h));
        s = Math.max(0, Math.min(100, s));
        v = Math.max(0, Math.min(100, v));

        // We accept saturation and value arguments from 0 to 100 because that's
        // how Photoshop represents those values. Internally, however, the
        // saturation and value are calculated from a range of 0 to 1. We make
        // That conversion here.
        s /= 100;
        v /= 100;

        if (s == 0) {
            // Achromatic (grey)
            r = g = b = v;
            return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
        }

        h /= 60; // sector 0 to 5
        i = Math.floor(h);
        f = h - i; // factorial part of h
        p = v * (1 - s);
        q = v * (1 - s * f);
        t = v * (1 - s * (1 - f));

        switch (i) {
            case 0:
                r = v;
                g = t;
                b = p;
                break;

            case 1:
                r = q;
                g = v;
                b = p;
                break;

            case 2:
                r = p;
                g = v;
                b = t;
                break;

            case 3:
                r = p;
                g = q;
                b = v;
                break;

            case 4:
                r = t;
                g = p;
                b = v;
                break;

            default: // case 5:
                r = v;
                g = p;
                b = q;
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

}
